import { createGlobalStyle } from 'styled-components';
import { darken } from '@material-ui/core/styles/colorManipulator';

export default createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }
  html,
  body,
  #root {
    height: 100%;
  }
  html{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5;
    background: ${props => props.theme.palette.background.default};
  }
  body, input, button {
    font: 15px 'Montserrat', sans-serif;
  }
  button {
    cursor: pointer;
  }

  .priorityZIndex {
    z-index: 999999 !important;
  }

  .swal2-container {
    z-index: 9999;
  }
  .swal2-styled, .swal2-confirm, .swal2-deny, .swal2-cancel {
    margin: 4px;
  }

  .button-danger {
    background-color: #d32f2f;
    color: #FFF;   
  }
  .button-danger:hover{
    background-color: ${darken('#d32f2f', 0.3)};
  }

  .button-error {
    background-color: #d32f2f;
    color: #FFF;   
  }
  .button-error:hover{
    background-color: ${darken('#d32f2f', 0.3)};
  }

  .button-warning{
    background-color: #ffa500;
    color: #FFF;   
  }
  .button-warning:hover{
    background-color: ${darken('#ffa500', 0.3)};
  }

  .button-success{
    background-color: #4caf50;
    color: #FFF;   
  }
  .button-success:hover{
    background-color: ${darken('#4caf50', 0.3)};
  }

  .button-primary{
    background-color: #0068e9;
    color: #FFF;   
  }
  .button-primary:hover{
    background-color: ${darken('#0068e9', 0.3)};
  }

  .button-info{
    background-color: #00abe3;
    color: #FFF;   
  }
  .button-info:hover{
    background-color: ${darken('#00abe3', 0.3)};
  }

  .button-question {
    background-color: #25708e;
    color: #FFF;   
  }
  .button-question:hover{
    background-color: ${darken('#25708e', 0.3)};
  }

  .button-white{
    background-color: #e0e0e0;
    color: #000;
  }
  .button-white:hover{
    background-color: ${darken('#e0e0e0', 0.3)};
  }

  iframe {
    pointer-events: none !important;
  }

  .app-swal-popup {
    background: var(--mui-bg) !important;
    color: var(--mui-text-primary) !important;
    box-shadow: var(--mui-shadow) !important;
  }
  .app-swal-toast {
    background: var(--mui-bg) !important;
    color: var(--mui-text-primary) !important;
    box-shadow: var(--mui-shadow) !important;
  }
  .swal2-title {
    color: var(--mui-text-primary) !important;
  }
  .swal2-html-container {
    color: var(--mui-text-secondary) !important;
  }

 `;

// const useStyles = makeStyles(() => createStyles({
//   '@global': {
//     '*': {
//       boxSizing: 'border-box',
//       margin: 0,
//       padding: 0,
//     },
//     html: {
//       '-webkit-font-smoothing': 'antialiased',
//       '-moz-osx-font-smoothing': 'grayscale',
//       height: '100%',
//       width: '100%'
//     },
//     body: {
//       height: '100%',
//       width: '100%'
//     },
//     '#root': {
//       height: '100%',
//       width: '100%'
//     }

//   }
// }));

// const GlobalStyles = () => {
//   useStyles();

//   return null;
// };

// export default GlobalStyles;
